module.exports = __webpack_public_path__ + "static/img/down_app.822ab28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/down_app.png
// module id = rcHv
// module chunks = 0